import { AlertCircle, CircleCheck, Loader } from "lucide-react";
import type { FpMessagePart } from "../../../../../schemas/codegen";

interface UnsupportedOperationProps {
  part: Extract<FpMessagePart, { type: "tool-call" }>;
}

export function UnsupportedOperation({ part }: UnsupportedOperationProps) {
  const command = part.args?.command as string;

  const statusIcon =
    part.status === "pending" ? (
      <Loader className="w-3 h-3 animate-spin" />
    ) : part.status === "complete" ? (
      <CircleCheck className="w-3 h-3 text-muted-foreground" />
    ) : null;

  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-md border bg-muted/50">
      <AlertCircle className="w-4 h-4 text-muted-foreground flex-shrink-0" />

      <div className="flex-1 min-w-0">
        <span className="text-sm font-medium truncate">
          Text editor operation failed:{" "}
          <span className="ml-1 font-mono font-thin text-foreground-muted">
            {command || "unknown"}
          </span>
        </span>
      </div>

      <div className="flex-shrink-0">{statusIcon}</div>
    </div>
  );
}
